<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create" icon="el-icon-plus" v-if="$permission.can('教学区')">{{isMB?'教学区':'教学区登记'}}</el-button>
        <el-button type="primary" @click="create2" icon="el-icon-plus" v-if="$permission.can('宿舍区')">{{isMB?'宿舍区':'宿舍区登记'}}</el-button>
        <!-- <el-button type="primary" @click="create" icon="el-icon-plus" v-if="$permission.canWrite()">添加</el-button> -->
        <!-- <el-dropdown>
          <el-button type="primary" style="margin-right: 10px;">
            添加<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="create(1)">教学区登记</el-dropdown-item>
            <el-dropdown-item @click.native="create(2)">宿舍区登记</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <el-button type="danger" @click="delRows">删除</el-button>
        <!-- <el-button size="mini" type="success" plain @click="onExport" v-if="!isMB">导出</el-button> -->
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="85">
          <template slot-scope="{row}">
            <el-button type="text" @click="editById(row.DisciplineRecordId)">编辑</el-button>
            <el-button type="text" @click="del(row.DisciplineRecordId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="toReload" />
    <create-dialog ref="createDialog" @close-saved="toReload" />
    <create-dialog2 ref="createDialog2" @close-saved="toReload" />
  </div>
</template>
<script>
let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));

import curdMixins from "@/mixins/curd";
import list from "@/components/st/quaregister/list";
import editDialog from "@/components/st/quaregister/editDialog";
import createDialog from "@/components/st/quaregister/createDialog";
import createDialog2 from "@/components/st/quaregister/createDialog2";

export default {
  name: "quaregister",
  mixins: [curdMixins],
  components: {
    list,
    createDialog,
    createDialog2,
    editDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    reload() {},
    toReload() {
      this.$refs.list.query();
    },
    // create() {
    //   if(loginInfo.HasDormitory) {
    //     this.$refs.createDialog2.openCreate()
    //   } else {
    //     this.$refs.createDialog.openCreate()
    //   }
    // },
    create() {
      this.$refs.createDialog.openCreate()
    },
    create2() {
      this.$refs.createDialog2.openCreate()
    },
    onExport() {
      this.$refs.list.onExport();
    },
    del(id) {
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.delRange([id]);
        })
        .catch(() => {});
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DisciplineRecordId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>